import { Collapse, Divider } from "antd";
import {
	SubmitButtonOverlay,
	ActionContainer,
	ActionItemsContainer,
} from "../../components/styled/common";
import { BannerItems } from "./constants";
import CollapseExpandIcon from "../../components/CollapseExpandIcon";
import MainButtonComponent from "../../components/MainButtonComponent";
import { useBannerContext } from "../../context/BannerContext/BannerContext";
import { useEffect } from "react";

const AddBanner = () => {
	const { addBanner, clearBannerFormData, setBannerForm, operationStatus } = useBannerContext();

	useEffect(() => {
		setBannerForm((prevForm) => ({ ...prevForm, isActive: false, bannerTypeEnum: 2 }));

		return () => {
			clearBannerFormData();
		};
	}, []);

	return (
		<ActionContainer>
			<ActionItemsContainer>
				<h3>Yeni Banner Ekleme</h3>
				<Divider />
				<Collapse
					items={BannerItems}
					expandIconPosition="end"
					bordered={false}
					ghost
					expandIcon={CollapseExpandIcon}
					defaultActiveKey={["1", "2", "3", "4"]}
				/>
				<SubmitButtonOverlay>
					<MainButtonComponent onClick={addBanner} loading={operationStatus.type === "loading" && operationStatus.operation === "add"}>
						Banner Ekle
					</MainButtonComponent>
				</SubmitButtonOverlay>
			</ActionItemsContainer>
		</ActionContainer>
	);
};

export default AddBanner;
